import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { assetUrl } from '../../common/helpers';
import Logo from './Logo';
import UI from '../../common/UI';
import UserNav from './UserNav';
import useMediaDevice from '../../common/useMediaDevice';
import useProject from '../useProject';

const TopBarContainer = styled(UI.Container)`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    display: flex;
    justify-content: space-between;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075), 0 3px 15px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 400;
    font-size: ${11 / 16}rem;

    ${UI.Caret} {
      border-top-color: ${theme.getColor('gray.300')};
    }
  `}
`;

const TopBar = () => {
  const mediaDevice = useMediaDevice();
  const project = useProject();
  const { t } = useTranslation();

  if (!mediaDevice.isSmall) {
    return null;
  }

  return (
    <TopBarContainer>
      <Logo to={project ? `/${project.id}/events` : '/'}>
        <img src={assetUrl('images/logo-color.svg')} alt={t('atleta')} />
      </Logo>

      <UserNav />
    </TopBarContainer>
  );
};

export default TopBar;
